import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <img src="/logo.svg" alt="TecMates Logo" className="footer-logo" />
            <p>TecMates Infocom Private Limited - Your trusted partner for end-to-end IT solutions.</p>
          </div>
          <div className="footer-section">
            <h3>Services</h3>
            <ul>
              <li><Link to="/services#infrastructure">IT Infrastructure</Link></li>
              <li><Link to="/services#networking">Networking</Link></li>
              <li><Link to="/services#security">Cybersecurity</Link></li>
              <li><Link to="/services#cloud">Cloud Solutions</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Company</h3>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/partners">Partners</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Contact</h3>
            <p><i className="fas fa-envelope"></i> info@tecmatesinfo.com</p>
            <div className="social-links">
              <a href="#"><i className="fab fa-linkedin"></i></a>
              <a href="#"><i className="fab fa-twitter"></i></a>
              <a href="#"><i className="fab fa-facebook"></i></a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 TecMates Infocom Private Limited. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 